import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { Phone, Mail } from "lucide-react";

export default function ContactBanner() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      className="py-16 bg-[#1C1917]"
      data-testid="contact-banner"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="flex flex-col lg:flex-row items-center justify-between gap-8"
        >
          <div className="text-center lg:text-left">
            <h3 className="font-['Outfit'] text-2xl md:text-3xl font-medium text-white mb-2">
              Ready to start your project?
            </h3>
            <p className="text-[#A8A29E]">
              Give us a call or text, or request a free quote online
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-6">
            {/* English Phone */}
            <a
              href="tel:+14358517485"
              className="flex items-center gap-3 bg-[#166534] hover:bg-[#14532D] text-white px-6 py-4 transition-colors group"
              data-testid="contact-phone-english"
            >
              <Phone size={24} className="group-hover:animate-pulse" />
              <div>
                <p className="text-xs text-white/70">English (Call/Text)</p>
                <p className="font-['Outfit'] text-xl font-medium">(435) 851-7485</p>
              </div>
            </a>

            {/* Spanish Phone */}
            <a
              href="tel:+14358514119"
              className="flex items-center gap-3 bg-white/10 hover:bg-white/20 text-white px-6 py-4 transition-colors group border border-white/20"
              data-testid="contact-phone-spanish"
            >
              <Phone size={24} className="group-hover:animate-pulse" />
              <div>
                <p className="text-xs text-white/70">Español (Llamar/Texto)</p>
                <p className="font-['Outfit'] text-xl font-medium">(435) 851-4119</p>
              </div>
            </a>
          </div>
        </motion.div>

        {/* Email */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-8 pt-8 border-t border-white/10 text-center"
        >
          <a
            href="mailto:Jvhomerenovationllc@gmail.com"
            className="inline-flex items-center gap-2 text-[#A8A29E] hover:text-white transition-colors"
            data-testid="contact-email"
          >
            <Mail size={18} />
            <span>Jvhomerenovationllc@gmail.com</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
